import React , {useEffect, useState} from "react";
import { Button } from "reactstrap";
import { useHistory } from "react-router-dom";
import Titlebanner from "../../../globel_cmponents/title_banner";
import axios from "axios";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AiTwotoneEdit } from "react-icons/ai";
import requests from "../../../utils/Requests";
const ListMealType = () => {
  const history = useHistory();
  const [rowData, setrowData] = useState([]);

  const [hotemIdList, stHotelIdList] = useState([])
  useEffect(() => {
    getHotelList();
  }, []);

  const getHotelList = async () => {
    await axios
      .post(requests.getMealTypeList, { mealTypeId: 1 })
      .then((res) => {
        console.log(res.data);
        const processData = res.data.map((item) => ({
          value: item.mealHotelId,
          name: item.hotelName
        }))
        stHotelIdList(processData)
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getMealTypeList();
  }, []);
  const getMealTypeList = () => {
    axios
      .post(requests.getMealTypeList, { hotelId: 1 })
      .then((res) => {
        console.log(res.data);
        setrowData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };


    const columnDefs = [
      { headerName: "Name", field: "mealName" },
     
      { headerName: "Actual Price ", field: "actualPrice" },
      { headerName: "Offer Price ", field: "offerPrice" },
      {
        headerName: "Actions",
        filter: false,
        field: "mealTypeId",
        cellRendererFramework: (params) => (
          <div>
            <Button color="primary" onClick={() => actionButton(params)}>
              <AiTwotoneEdit />
            </Button>
          </div>
        ),
      },
    ];


    const hotelName = () =>{
      
    }

    const actionButton = (params) => {
      history.push(
        `/Meals/MealsHotel-CreateorupdateMealstype/${params.data.mealTypeId}`
      );
    };

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
    floatingFilter: true,
  };
  return (
    <div>
      <Titlebanner title="Meals Type List" />
      <Button
        color="primary"
        onClick={() => history.push(`/Meals/MealsHotel-CreateorupdateMealstype/null`)}
      >
        Create New
      </Button>

              <div className="App">
                    <div className="ag-theme-alpine" style={{ height: "500px" }}>
                      <AgGridReact
                        columnDefs={columnDefs}
                        rowData={rowData}
                        defaultColDef={defaultColDef}
                        // onGridReady={onGridReady}
                        pagination={true}
                        // paginationPageSize={5}
                        // paginationAutoPageSize={true}
                        alwaysShowHorizontalScroll={true}
                        alwaysShowVerticalScroll={true}
                      ></AgGridReact>
                    </div>
                  </div>
    </div>
  );
};

export default ListMealType;